// import { useSelector } from 'react-redux'
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { today } from "./helpers";

function DaterangeSelector({
  from = today,
  to = today,
  handleChange = (f) => f,
  noLabel = false,
  space = true,
}) {
  // const activeBusiness = useSelector((state) => state.auth.activeBusiness)

  return (
    <Row>
      <Col md={space ? 4 : 5}>
        <FormGroup>
          {!noLabel && <Label style={{ fontWeight: "bold" }}>From:</Label>}
          <Input
            type="date"
            value={from}
            name="from"
            onChange={handleChange}
            style={{
              borderWidth: 1,
              marginBottom: 30,
              backgroundColor: "#fff",
              // borderColor: activeBusiness.primary_color,
            }}
          />
        </FormGroup>
      </Col>

      <Col md={space ? 4 : 1}></Col>

      <Col md={space ? 4 : 5}>
        <FormGroup>
          {!noLabel && <Label style={{ fontWeight: "bold" }}>To:</Label>}
          <Input
            type="date"
            value={to}
            name="to"
            onChange={handleChange}
            style={{
              borderWidth: 1,
              backgroundColor: "#fff",
              // borderColor: activeBusiness.primary_color,
            }}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default DaterangeSelector;
